

require('angular').module('clientDashboardApp.reviewBuilder').factory("getAddContactsLink", ["$uibModal", "locationService", "$location", function($uibModal, locationService, $location) {

  function createLink(campaignId, locationId) {
    let portString = $location.port() == 80 ? '' : `:${$location.port()}`

    return `${$location.protocol()}://${$location.host()}${portString}/` +
      `reviewBuilder/campaign/${campaignId}/contacts${locationId ? `?locationId=${encodeURIComponent(locationId)}` : ''}`;
  }

  function setCampaignLocations(vm, accountLocations) {
    if (vm.campaign.groupId) {
      locationService.loadLocationGroup(vm.campaign.groupId).then(function (data) {
        vm.locations =
          _.sortBy(data
            .map(locationService.formatLocation)
            .map(location => {
              location.locationId = location.locationId.substr(7);
              return location;
            }), 'summary');
      })
    }
    else {
      vm.locations = _.sortBy(accountLocations.map(locationService.formatLocation), 'summary');
    }
  }

  return {
    openModal: function(campaign) {
      $uibModal.open({
        template: require('./getAddContactsLink.html'),
        controller: function() {
          let vm = this;
          vm.campaign = campaign
          vm.selectedLocation = null;

          locationService.locationsForAccount(campaign.accountId).then(locations => {
            setCampaignLocations(vm, locations)
          })

          vm.generateLink = function() {
            return createLink(campaign._id.$oid, vm.selectedLocation)
          }
        },
        controllerAs: 'vm'
      })
    }
  }

}])
